import { Icon } from '@iconify/react'
import clsx from 'clsx'

import type { ButtonProps } from '~/types/component'

const Button = ({
  type,
  variant,
  size,
  font,
  icon,
  rounded,
  plain,
  block,
  disabled,
  isLoading,
  onClick,
  children,
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={clsx(
        'inline-flex items-center justify-center gap-2 border px-4 font-bold hover:border-gray-800 hover:bg-gray-800',
        'disabled:border-gray-400 disabled:bg-gray-400',
        [!variant && 'border-gray-500 bg-gray-500'],
        [
          variant === 'primary' && [
            plain
              ? 'border-jba-shadeBlue bg-jba-shadeBlue text-gray-800 hover:border-jba-lightBlue hover:bg-jba-lightBlue hover:text-white'
              : 'border-jba-blue bg-jba-blue text-white hover:border-jba-lightBlue hover:bg-jba-lightBlue',
          ],
        ],
        [
          variant === 'secondary' && [
            plain
              ? 'border-jba-shadeRed bg-jba-shadeRed text-gray-800 hover:border-jba-lightRed hover:bg-jba-lightRed hover:text-white'
              : 'border-jba-red bg-jba-red text-white hover:border-jba-lightRed hover:bg-jba-lightRed',
          ],
        ],
        [plain && 'disabled:text-white'],
        [!size && 'h-[42px]'],
        [size === 'large' && 'h-full w-full text-2xl'],
        [font === 'lg' && [size !== 'large' ? 'text-lg' : 'text-xs']],
        [rounded === 'xl' ? 'rounded-xl' : 'rounded-lg'],
        [block && 'w-full'],
      )}
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      {isLoading && (
        <Icon
          icon="material-symbols:progress-activity"
          className={clsx('shrink-0 animate-spin text-white', [size === 'large' ? 'text-xl' : 'text-lg'])}
        />
      )}
      {!isLoading && icon && (
        <Icon icon={icon} className={clsx('shrink-0 text-white', [size === 'large' ? 'text-xl' : 'text-lg'])} />
      )}
      {children}
    </button>
  )
}

export default Button
